import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import type { PitchFeature } from "@/types/camping";

/** Lädt die Platz-Eigenschaften (Stammdaten) des Mandanten. */
export function usePitchFeatures(active = true) {
  const [features, setFeatures] = useState<PitchFeature[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(() => {
    setLoading(true);
    api
      .get<PitchFeature[]>("/api/v1/pitch-features")
      .then((list) => {
        setFeatures(list);
        setError(null);
      })
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!active) return;
    reload();
  }, [active, reload]);

  return { features, loading, error, reload };
}

export function featureNameById(features: PitchFeature[]): Map<string, string> {
  return new Map(features.map((f) => [f.id, f.name]));
}
